import {useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {setResourceActiveTab, setResourceCurrentView} from '../../../redux/slices/resources';
import {TabType, ViewType} from '../../../pages/Resource/types';
import {OnboardingStepKeyEnum} from '../types';
import {useOnboardingRoadmap} from './useOnboardingRoadmap';

export function useOnboardingNavigator() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { steps } = useOnboardingRoadmap();

  const includedKeys = useMemo(() => steps.filter(s => s.include).map(s => s.key), [steps]);

  const navigateIfDifferent = useCallback((pathname: string, search: string = '', hash: string = '') => {
    const target = `${pathname}${search}${hash}`;
    const w = typeof window !== 'undefined' ? window.location : null;
    const current = w ? `${w.pathname}${w.search}${w.hash}` : `${location.pathname}${location.search}${location.hash}`;
    if (current !== target) {
      navigate({ pathname, search, hash });
    }
  }, [navigate, location.pathname, location.search, location.hash]);

  const goToStep = useCallback((key: OnboardingStepKeyEnum | undefined) => {
    if (!key) return;
    switch (key) {
      case OnboardingStepKeyEnum.RiskMitigation:
        // navigateIfDifferent('/strategymaps');
        break;
      case OnboardingStepKeyEnum.PmTools:
        // navigate("/#onboarding");
        // navigateIfDifferent('/settings', '', '#Integrations');
        break;
      case OnboardingStepKeyEnum.ImportUsers:
        navigateIfDifferent('/people');
        break;
      case OnboardingStepKeyEnum.ImportTeams:
        navigateIfDifferent('/teams');
        break;
      case OnboardingStepKeyEnum.OrgSkills:
        // navigateIfDifferent('/settings', '', '#OrgSkills');
        break;
      case OnboardingStepKeyEnum.StrategyMap:
        // navigateIfDifferent('/strategymaps');
        break;
      case OnboardingStepKeyEnum.Explore:
        // navigateIfDifferent('/workitems');
        break;
      case OnboardingStepKeyEnum.AllocateSkills:
        navigateIfDifferent('/people');
        break;
      case OnboardingStepKeyEnum.OrgHolidays:
        // navigateIfDifferent('/settings', '', '#Schedules');
        break;
      default:
        break;
    }
  }, [dispatch, navigate, navigateIfDifferent]);

  const getNextAfter = useCallback((currentKey: OnboardingStepKeyEnum) => {
    const idx = includedKeys.indexOf(currentKey);
    if (idx === -1) return undefined;
    for (let i = idx + 1; i < includedKeys.length; i++) {
      const candidateKey = includedKeys[i];
      const step = steps.find(s => s.key === candidateKey);
      if (step && !step.done && step.include) return candidateKey;
    }
    return undefined;
  }, [includedKeys, steps]);

  const goToNextFrom = useCallback((currentKey: OnboardingStepKeyEnum) => {
    const next = getNextAfter(currentKey);
    if (next) {
      // Slight deferral so any state updates (like marking current complete) can propagate
      setTimeout(() => goToStep(next), 0);
    }
    return next;
  }, [getNextAfter, goToStep]);

  return { goToNextFrom, goToStep, getNextAfter };
} 